import { environment } from '@environments/environment';
import { SistemaPinType } from '@interfaces/sistema-pin.interface';

export const autoCompleteInput: 'on' | 'off' = !environment.production
  ? 'off'
  : 'on';

export const SISTEMA_PIN: SistemaPinType = 'Cotizador Directo';
